import React, { useState, useEffect } from 'react'
import { Flex, Text, Pane, Label } from '@leverege/ui-elements'
import { Attributes } from '@leverege/ui-attributes'
import classnames from 'classnames'
import S from './MoldHalfCard.css'
import GetStageFormat from '../../../util/Stage'
import { categories } from '../../../Constants'

const nullNaNDefault = ( checkVal, retVal, backup ) => {
  if ( Number.isNaN( checkVal ) ) return backup
  return retVal
}

function MoldHalfCard( props ) {

  const { 
    half,
    name = 'Shell'
  } = props

  const [ stageDuration, setStageDuration ] = useState()

  const startTimestamp = Attributes.get( 'moldHalf.currentStageStartedAt', half )
  const stage = Attributes.get( 'moldHalf.currentStage', half )
  // TODO: use attributes
  const countByCategory = half?.data?.data?.workerCountByCategory || {}
  const {
    [categories.DIRECT] : direct,
    [categories.INDIRECT] : indirect,
    [categories.INDIRECT_OTHER] : indirectOther,
    [categories.UNCATEGORIZED] : uncategorized,
  } = countByCategory
  useEffect( () => {

    function updateLiveTime() {
      setStageDuration( timeBetweenString( startTimestamp, Date.now() ) )
    }

    const interval = setInterval( updateLiveTime, 1000 )
    updateLiveTime() // Initial call to set the state immediately

    return () => clearInterval( interval ) // Cleanup interval on component unmount
  }, [ startTimestamp ] )

  const formattedStartTime = formatTimestamp( startTimestamp )
  const stageStyle = GetStageFormat( stage )

  return (
    <div className={S.container}>
      <div className={S.header}>{name}</div>
      <div className={S.body}>

        <div className={classnames( S.stageIndicator, S[stageStyle.className || stage] )}>{stageStyle.name}</div>

        <Pane layout="flex:colL">
          <Flex variant="colS">
            <Label variant="moldHalfDetailLabel">Start Time</Label>
            <Text className={S.startTime} variant="moldHalfStageDetailValue">{formattedStartTime}</Text>
          </Flex>
          <Flex variant="colS">
            <Label variant="moldHalfDetailLabel">Stage Duration</Label>
            <Text classname={S.duration} variant="moldHalfStageDetailValue">{nullNaNDefault( startTimestamp, stageDuration, '-' )}</Text>
          </Flex>
        </Pane>

        <div className={S['hr-divider']} />
        <Pane layout="flex:colM">
          <Text variant="workerCountTitle|captionBold">Workers Detected</Text>
          <Flex variant="rowSpaceBetween">
            <Label variant="moldHalfDetailLabel">Direct</Label>
            <Text variant="moldHalfDetailValue">
              {direct ?? '-'}
            </Text>
          </Flex>

          <Flex variant="rowSpaceBetween">
            <Label variant="moldHalfDetailLabel">Indirect</Label>
            <Text variant="moldHalfDetailValue">
              {indirect ?? '-'}
            </Text>
          </Flex>

          <Flex variant="rowSpaceBetween">
            <Label variant="moldHalfDetailLabel">Indirect Other</Label>
            <Text variant="moldHalfDetailValue">
              {indirectOther ?? '-'}
            </Text>
          </Flex>

          <Flex variant="rowSpaceBetween">
            <Label variant="moldHalfDetailLabel">Uncategorized</Label>
            <Text variant="moldHalfDetailValue">
              {uncategorized ?? '-'}
            </Text>
          </Flex>
        </Pane>

      </div>
     
    </div>
  )
}

function timeBetweenString( startTS, endTS ) {

  if ( startTS == null || endTS == null || Number.isNaN( startTS ) || Number.isNaN( endTS ) ) return '-'

  const ONE_MIN_MS = 60000
  const elapsed = endTS - startTS

  const totalMinutes = Math.floor( elapsed / ONE_MIN_MS )
  const hours = Math.floor( totalMinutes / 60 )
  const minutes = totalMinutes % 60

  const hoursStr = hours > 0 ? `${hours} h` : ''
  const minutesStr = minutes > 0 ? `${minutes} m` : ''
  
  return `${hoursStr} ${minutesStr}`.trim()
}

function formatTimestamp( timestamp ) {

  if ( timestamp == null || Number.isNaN( timestamp ) ) return '-'

  const date = new Date( timestamp )
  
  const months = date.getMonth() + 1 // Months are zero-based
  const days = date.getDate()
  let hours = date.getHours()
  const minutes = date.getMinutes()
  const ampm = hours >= 12 ? ' PM' : ' AM'

  hours %= 12
  hours = hours || 12 // The hour '0' should be '12'
  const minutesStr = minutes < 10 ? `0${minutes}` : minutes

  return `${months}/${days} ${hours}:${minutesStr}${ampm}`
}

export default MoldHalfCard
